// 011 Slice 1 (server 009, 010): the parent's orders, through the generated client. A context lets
// tests inject fakes. Order data stays in component memory only (FR-032): nothing is stored, and the
// delivery code is never logged (FR-020).
import { createContext, useContext } from "react";

import { api } from "@/api";
import { type ApiClient, unwrap } from "@/api/client";
import type { Api } from "@/api/types";

export type OrdersTab = "all" | "active" | "delivered";

export type OrdersClient = {
  listOrders(tab: OrdersTab, page: number): Promise<Api["ParentOrderPage"]>;
  getOrder(orderId: string): Promise<Api["ParentOrder"]>;
};

export function createOrdersClient(client: ApiClient): OrdersClient {
  return {
    listOrders: (tab, page) =>
      unwrap(
        client.GET("/api/v1/orders", {
          params: { query: { tab, page, size: 25 } },
        }),
      ),
    getOrder: (orderId) =>
      unwrap(
        client.GET("/api/v1/orders/{orderId}", {
          params: { path: { orderId } },
        }),
      ),
  };
}

export const OrdersClientContext = createContext<OrdersClient>(
  createOrdersClient(api),
);
export const useOrdersClient = () => useContext(OrdersClientContext);
